import axios from "axios";

import type { ApiError } from "./ApiError";
import { isApiError } from "./ApiError";

type ApiErrorBody = {
  code?: unknown;
  message?: unknown;
  details?: unknown;
};

export const normalizeApiError = (error: unknown): ApiError => {
  if (axios.isAxiosError(error)) {
    const status = error.response?.status;
    const body = error.response?.data as ApiErrorBody | undefined;
    const timedOut =
      error.code === "ECONNABORTED" ||
      error.code === "ETIMEDOUT" ||
      status === 408 ||
      status === 504;
    return {
      status,
      code: typeof body?.code === "string"
        ? body.code
        : timedOut
          ? "REQUEST_TIMEOUT"
          : !error.response
            ? "NETWORK_ERROR"
            : status && status >= 500
              ? "SERVER_ERROR"
              : "UNKNOWN_API_ERROR",
      message: typeof body?.message === "string"
        ? body.message
        : timedOut
          ? "サーバーの応答がタイムアウトしました。しばらくしてからもう一度お試しください。"
          : !error.response
            ? "サーバーに接続できません。"
            : "リクエストに失敗しました。",
      details: body?.details,
      cause: error,
    };
  }

  if (isApiError(error)) return error;

  return {
    code: "UNKNOWN_ERROR",
    message: error instanceof Error ? error.message : "不明なエラーが発生しました。",
    cause: error,
  };
};
